(function () {
  function marcar(img) {
    if (img.dataset.acsSkel || img.getAttribute('fetchpriority') === 'high') return;
    if (img.complete) {
      if (img.naturalWidth === 0 && img.getAttribute('src')) {
        img.dataset.acsSkel = '1';
        img.classList.add('acs-skel', 'acs-skel-fade', 'acs-skel-quieto');
      }
      return;
    }
    img.dataset.acsSkel = '1';
    img.classList.add('acs-skel', 'acs-skel-fade');
    img.addEventListener('load', () => img.classList.replace('acs-skel', 'acs-skel-listo'));
    img.addEventListener('error', () => img.classList.add('acs-skel-quieto'));
  }
  document.querySelectorAll('img').forEach(marcar);
  new MutationObserver((muts) => {
    muts.forEach((mu) => {
      mu.addedNodes.forEach((n) => {
        if (n.nodeType !== 1) return;
        if (n.tagName === 'IMG') marcar(n);
        else if (n.querySelectorAll) n.querySelectorAll('img').forEach(marcar);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
